import styled from 'styled-components/macro';

import bg from 'assets/img/ag_register_mobile.svg';

export const AdriagateStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  h3 {
    @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
      color: ${({ theme }) => theme.colors.white};
      font-family: ${({ theme }) => theme.fontFamily.medium};
      font-size: 1.75rem;
      padding: 2rem 0 1rem;
    }
  }

  label {
    font-family: ${({ theme }) => theme.fontFamily.medium};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
    background-image: url(${bg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    overflow-x: hidden;
  }
`;
